const SmallTile = () => {
  return (
    <div className="round-lg h-[200px] w-[150px] shrink-0 rounded-xl border border-gray-300 bg-white px-4 py-3"></div>
  );
};

export default SmallTile;
